module.exports = require('./helpers/bundle-url').getBundleURL('iE43R') + "logo.c51670a8.svg";